<notifications [preview]="true" [previewContent]="content"></notifications>
